import React from 'react';
import SearchBar from "./SearchBar";

const NavIcon = ({icon, name, color, type, filterLocation, selected, count}) => {
    return (
        <span className={"nav-link px-1" + (selected ? " border border-accent" : "")} onClick={() => filterLocation(type)}>
            <i className={"fa fa-" + icon + " circle-icon solid attr " + (selected ? 'bg-accent' : '')} style={selected ? null : {backgroundColor:color}}></i>
            <span className={selected ? "d-block text-accent" : "d-block text-body"}>{ __(name) }</span>
            {count && <span className="badge bg-accent">{count}</span>}
        </span>
    )
};

export default NavIcon;
